<template>
  <div class="signature-content">
    <div class="tip">
      {{ $t("pages_scanSignature_index_322") }}
      <span>{{ formatDuration(currentDuration) }}</span>
      {{ $t("pages_scanSignature_index_323") }}
    </div>
    <div class="container">
      <div class="qrcode-wrapper">
        <div class="qr-code" ref="qrCode"></div>
        <p class="intro">
          {{ $t("pages_scanSignature_index_324") }} <br />{{
            $t("pages_scanSignature_index_325")
          }}
        </p>
      </div>
      <div class="result-wrapper">
        <div class="result">
          <img v-if="imageUrl" :src="imageUrl" alt="signature" />
          <span v-else>{{ $t("pages_scanSignature_index_326") }}</span>
        </div>
        <p class="intro">{{ $t("pages_scanSignature_index_327") }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import QRCode from "qrcodejs2";
import websocket from "@/utils/websocket.js";
import { getLastEleSignUrl, getCode } from "@/api/courseApi/index.js";
import { mapGetters } from "vuex";
import { UMOOC_WEB_HOST } from "@/config";
export default {
  name: "ScanSignature",
  data() {
    return {
      qrcode: null,
      defaultDuration: 5 * 60,
      currentDuration: this.defaultDuration,
      timer: 0,
      imageUrl: "",
    };
  },
  computed: {
    ...mapGetters({ token: "user/token" }),
    isTimeOver() {
      return this.websocketIsOver;
    },
    websocketIsOver() {
      if (this.currentDuration <= 0) {
        // websocket.disconnect()
        return true;
      }
      return false;
    },
  },
  mounted() {
    this.currentDuration = this.defaultDuration;
    this.getLastEleSignUrl();
    this.$nextTick(() => {
      this.creatQrCode();
      this.initTimer();
      window.top &&
        window.top.postMessage(
          {
            code: "setHeight",
            height: document.querySelector(".signature-content").offsetHeight,
          },
          "*"
        );
    });
    this.registMessage();
  },
  methods: {
    connect(code) {
      if (!websocket.isConnected) {
        websocket.connect(code);
      } else {
        websocket.subscribe(code);
      }
    },
    creatQrCode() {
      this.qrcode && this.qrcode.clear();
      getCode().then(({ result }) => {
        if (result) {
          // websocket没有接口，暂时不用
          // this.connect(result)
          const url = `${UMOOC_WEB_HOST}/mobile.html#/signature?code=${result}&token=${this.token}&loginCode=1`;
          if (!this.qrcode) {
            this.qrcode = new QRCode(this.$refs.qrCode, {
              text: url,
              width: 178,
              height: 178,
              colorDark: "#444444",
              colorLight: "#ffffff",
              correctLevel: QRCode.CorrectLevel.H,
            });
          } else {
            this.qrcode.makeCode(url);
          }
          this.qrcode._el.title = "";
        }
      });
    },
    getLastEleSignUrl() {
      getLastEleSignUrl().then(({ result }) => {
        this.imageUrl = result || "";
      });
    },
    initTimer() {
      this.closeTimer();
      this.timer = setInterval(() => {
        if (this.currentDuration > 0) {
          this.currentDuration--;
          this.getLastEleSignUrl();
        } else {
          this.close();
        }
      }, 1000);
    },
    closeTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    close() {
      window.top &&
        window.top.postMessage(
          {
            code: "close",
          },
          "*"
        );
      this.closeTimer();
    },
    registMessage() {
      websocket.registMessageListener(1, (data) => {
        if (data.id && data.content === "refresh") {
          cosnole.log("refresh");
          this.getLastEleSignUrl();
        }
      });
    },
    formatDuration(duration) {
      if (!duration) {
        return "00:00";
      }
      const setZero = (val) => {
        return val > 9 ? val : `0${val}`;
      };
      const s = duration % 60;
      const m = Math.floor(duration / 60);
      return `${setZero(m)}:${setZero(s)}`;
    },
  },
  beforeDestroy() {
    // websocket && websocket.disconnect()
  },
};
</script>
<style lang="scss" scoped>
.signature-content {
  padding: 6px 30px 20px;
  background-color: #fff;
  text-align: center;
  .tip {
    margin-bottom: 20px;
    span {
      font-weight: 500;
      color: $--color-danger;
    }
  }
  .container {
    display: flex;
    > div {
      width: 220px;
      .qr-code,
      .result {
        margin: 0 auto;
        width: 178px;
        height: 178px;
      }
      .intro {
        margin: 16px 0 0;
      }
    }
    .result-wrapper {
      margin-left: 20px;
      .result {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 178px;
        padding: 0 15px;
        border-radius: 3px;
        border: $--border-base;
        img {
          max-width: 100%;
        }
        span {
          color: $--color-text-secondary;
        }
      }
    }
  }
}
</style>
